/* global  showSavingsPlanOffer*/
import CONSTANTS from '../lib/constants';
import events from 'events-bus';
import { sendAdobeData } from '../utils';

let SAVINGSPLAN = {};

SAVINGSPLAN.init = function () {
  initSavingsPlanBoxEvents();
  trackSavingsPlanEligibility();
};

function initSavingsPlanBoxEvents() {
  //Hide SP box space reservation after 2 secs, if no box is shown
  setTimeout(() => {
    let spBox = $('#savings-plan-offer-box-wrapper').html();
    if (!spBox) {
      hideSavingsPlanBox();
    }
  }, 2000);
  //If there is a failure in getting the SP box, we remove the space reservation
  events.on(CONSTANTS.SAVINGS_PLAN_OFFER_FAILURE, () => {
    hideSavingsPlanBox();
  });
}

function hideSavingsPlanBox() {
  $('.sp__box__fixed').css({ 'min-height': '0', display: 'block' });
  $('.sp__box-twoColumns').css({ 'min-height': '0', display: 'block' });
  $('.sp__in_cart').css({ 'min-height': '0', display: 'block' });
}

function trackSavingsPlanEligibility() {
  setTimeout(() => {
    if (typeof showSavingsPlanOffer !== 'undefined' && showSavingsPlanOffer) {
      sendAdobeData('savingPlanEligible');
    }
  }, 1000);
}

export default SAVINGSPLAN;
